import request from '@/utils/request'
//获取学年学期联动树列表
export function gettreelist(params) {
    return request({
        url: '/common/semester/get-list',
        method: 'GET',
        params
    })
}


